function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon_addition");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u89C6\\u9891\\u9AD8\\u7EA7\\u7F16\\u8F91-\\u5B57\\u5E55",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u5185\\u5BB9\\u5236\\u4F5C-\\u5B57\\u5E55",
  transform: "translate(-200.000000, -129.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-12\\u5907\\u4EFD",
  transform: "translate(160.000000, 60.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7EE7\\u7EED\\u4E0A\\u4F20",
  transform: "translate(30.000000, 66.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u6279\\u91CF\\u5BFC\\u5165",
  transform: "translate(10.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "icon_addition",
  x: 0,
  y: 0,
  width: 20,
  height: 20
}), /*#__PURE__*/React.createElement("path", {
  d: "M10,3 C10.4142136,3 10.75,3.33578644 10.75,3.75 L10.75,9.25 L16.25,9.25 C16.6642136,9.25 17,9.58578644 17,10 C17,10.4142136 16.6642136,10.75 16.25,10.75 L10.749,10.75 L10.75,16.25 C10.75,16.6642136 10.4142136,17 10,17 C9.58578644,17 9.25,16.6642136 9.25,16.25 L9.249,10.75 L3.75,10.75 C3.33578644,10.75 3,10.4142136 3,10 C3,9.58578644 3.33578644,9.25 3.75,9.25 L9.25,9.25 L9.25,3.75 C9.25,3.33578644 9.58578644,3 10,3 Z",
  id: "\\u5F62\\u72B6\\u7ED3\\u5408",
  fill: "#38B66A"
}))))));

var SvgIconAddition = function SvgIconAddition(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAddition, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_addition.92e07fea.svg";
export { ForwardRef as ReactComponent };